import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AuthStore} from "@app/authentication";

export const AuthenticationGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  if (!authStore.isAuthenticated()) {
    authStore.logout();
    return false;
  }
  return true;
};
